module.exports = __webpack_public_path__ + "img/GAME_COLORPAPER2.671596da.jpg";